export enum VehicleMode {
  // Bidding company has to assign one unique vehicle to a bid
  ONE_TO_ONE = 0,
  // Bidding company bids on several lots and offers a certain pool of vehicles
  // that has to be assigned to the winning lots
  POOL = 1
}